import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

export const ExpertsSection = () => (
	<section className="experts">
		<div className="container section-wrapper">
			<h2 className="section-title">
				Meet the Research Team Behind the Global Passport Index
			</h2>
			<div className="section-content experts__content">
				<div
					className="experts__block"
					data-sal="slide-up"
					data-sal-delay={100 + 0 * 150}
					data-sal-duration="350"
					data-sal-easing="ease"
				>
					<div className="experts__photo">
						<StaticImage
							src="../images/experts-1.jpg"
							alt="Dr. Roberto de Pinho"
							width={220}
							height={220}
							className="experts__photo-img"
						/>
					</div>
					<div className="experts__info">
						<h3 className="experts__name mb-4">
							Dr. Roberto de Pinho
						</h3>
						<div className="section-text">
							<p className="mb-4">Hailing from Brazil, Roberto has an academic background in computer science and energy industry regulation. He’s spent the last decade working in Science, Technology and Innovation Policy and Indicators, with a keen interest in bibliometrics, scientific metrics, and data science. </p>

							<p className="mb-4">Having collaborated with various institutions like OECD, UNESCO, and the Intergovernmental Oceanographic Commission of UNESCO (IOC), Roberto has produced policy-relevant studies, working papers, and reference documents, working with other international experts.</p>

							<p>Whether designing a program from scratch or analyzing a problem, Roberto uses data as part of his day-to-day operations. Finding reliable sources is a critical component of his work, and his expertise lies in connecting meaningful data to science and innovation.</p>
						</div>
					</div>
				</div>
				<div
					className="experts__block"
					data-sal="slide-up"
					data-sal-delay={100 + 1 * 150}
					data-sal-duration="350"
					data-sal-easing="ease"
				>
					<div className="experts__info">
						<h3 className="experts__name mb-4">
							Vladimir López-Bassols
						</h3>
						<div className="section-text">
						<p className="mb-4">Originally from Mexico, Vlad spent his life shuffling between numerous countries before settling down in Washington D.C. as an independent consultant for international organizations like UNESCO and the World Bank. </p>

						<p className="mb-4">With an academic background in maths and statistics, Vlad initially spent twenty years in Paris at the Organisation for Economic Co-operation and Development (OECD), working on statistics and data in the science and technology sector. His specialty lies in simplifying complex technical work, harmonizing data from different countries and sources, and in turn, delivering statistical research with vigor. </p>

						<p>Having worked with composite indicators before, Vlad was particularly inspired by Global Citizen Solution’s mission to create its own version of the Passport Index. For Vlad, it’s not just about data; it’s about connecting numbers to messages and creating meaning for the individual.</p>

						</div>
					</div>
					<div className="experts__photo">
						<StaticImage
							src="../images/experts-2.jpg"
							alt="Vladimir López-Bassols"
							width={220}
							height={220}
							className="experts__photo-img"
						/>
					</div>
				</div>
			</div>
		</div>
	</section>
);
